import createReducer from '../utils/createReducer';
import {
  TAGS_REQUEST,
  TAGS_FAILURE,
  TAGS_SUCCESS,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null,
};

export default createReducer(initialState, {
  [TAGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [TAGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: {
        ...state.data,
        [payload.type]: payload.data ? [].concat(payload.data) : [],
      },
      token: payload.token,
    })
  ),
  [TAGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/tags.js